<template>
  <div :style="{width: width+'px'}" class="commonModal">
       <a class="ivu-modal-close" @click="closeDialog"  v-if="title && isClose">
           <i class="ivu-icon ivu-icon-ios-close"></i>
       </a>
       <div class="ivu-modal-header" v-if="title">
         <div class="ivu-modal-header-inner">{{title}}</div>
       </div>
       <div  style="
       text-align: left;
       color: #333;
       padding: 21px 47px 40px 28px;">{{content}}</div>
      <div class="btn-modal" v-if="btnNumber">
         <Button @click="modelCancel" :class="cancelText==CONFERENCEMEET.LEAVE_MEET_NAME?'red_btn':'cancel_model_btn'">{{cancelText}}</Button>
         <Button type="primary" style="bottom: 0px;margin-right: 20px" @click="modelOk">{{okText}}</Button>
      </div>
     <div class="onebtn-modal" v-else>
       <Button type="primary" style="right: 20px;bottom: 0px;" @click="modelOk">{{okText}}</Button>
     </div>
  </div>
</template>
<script>
    export default {
        props:['title','content','okText','cancelText','isClose','btnNumber','width'],
        name: "tips-dialog",
        data(){
           return {}
        },
        methods:{
          closeDialog(){
             this.$emit('close_modal');
             this.$Modal.remove()
          },
          modelCancel(){
            this.$emit('cancel_modal');
            this.$Modal.remove()
          },
          modelOk(){
            this.$emit('confirm_modal');
            this.$Modal.remove()
          }
        }

    }
</script>

<style scoped>
.btn-modal,.onebtn-modal{
    text-align: right;
    height: 40px;
    position: relative;
}
.red_btn{bottom: 0px;min-width: 80px;line-height: 22px;position: absolute;right: 21px;height: 35px;background-color: #de353d;font-size: 16px;border: 1px solid #de353d;color: #fff;}
.red_btn:hover{background-color: #ca333a}
.red_btn:active{background-color: #ab272d}
.cancel_model_btn{bottom: 0px;min-width: 80px;position: absolute;right: 21px;height: 35px;background-color: #f0f0f0;font-size: 16px;border: 1px solid #c8c8c8;color: #333;}
.cancel_model_btn:hover{background-color: #d4d4d4;border-color: #c8c8c8;color: #333}
.cancel_model_btn:active{background-color: #aaa;border-color: #c8c8c8;color: #333}
.cancelbtnstyle{background-color: #222224;
    border: 1px solid #4f4f51;color: #fff}
</style>
